import {
  setMainContentNavList,
  setMainContentFieldList,
  setMainContentMessageList,
  setMainContentShowHeaders,
} from "./MainContentSlice";
import { store } from "../../app/store";
import { INavigation } from "../../app/types";

export const setShowHeaders = () => {
  return new Promise((resolve, reject) => {
    /* Get state */
    const state = store.getState();

    resolve(
      store.dispatch(setMainContentShowHeaders(!state.mainContent.showHeaders))
    );
  });
};

export const resetMessageList = () => {
  return new Promise((resolve, reject) => {
    resolve(store.dispatch(setMainContentMessageList([])));
  });
};

export const setFieldValue = (name: string, value: any, idx?: number) => {
  return new Promise((resolve, reject) => {
    /* Get state */
    const state = store.getState();

    /* Find the item in Fieldlist */
    if (
      state.mainContent.fieldList &&
      state.mainContent.fieldList.findIndex((field) => field.name === name) >= 0
    ) {
      /* Set value of fields in FieldList */
      const fieldList = state.mainContent.fieldList.map((fld) => {
        if (
          fld.name === name &&
          fld.grid &&
          fld.rows &&
          fld.rows.length &&
          idx &&
          idx === -1
        ) {
          // Update value of entire rows coz of selectAll attribute
          return {
            ...fld,
            value: value.toString(),
            rows: fld.rows.map((row) => {
              if (row.editable && row.editable === "true") {
                return { ...row, value: value.toString(), isModified: true };
              } else return { ...row };
            }),
          };
        } else if (
          fld.name === name &&
          fld.grid &&
          fld.rows &&
          fld.rows.length &&
          idx &&
          fld.rows[idx - 1]
        ) {
          // Update value of a grid field alonwith header value for selectAll attribute

          if (
            (fld.value && value.toString() === "false") ||
            (fld.value &&
              value.toString() === "true" &&
              fld.rows.find(
                (row) =>
                  row.editable === "true" &&
                  row.value === "false" &&
                  row.row !== idx
              ) === undefined)
          )
            return {
              ...fld,
              value: value.toString(),
              rows: fld.rows.map((row) => {
                if (row.row === idx && row.editable === "true") {
                  return { ...row, value: value.toString(), isModified: true };
                } else return { ...row };
              }),
            };
          // Update value of a grid field
          else
            return {
              ...fld,
              rows: fld.rows.map((row) => {
                if (row.row === idx && row.editable === "true") {
                  return { ...row, value: value.toString(), isModified: true };
                } else return { ...row };
              }),
            };
        } else if (fld.name === name && value !== null) {
          // Updating value of an individual field

          return {
            ...fld,
            value: value.replace(/&#xA;/gi, "\n"), // removed trim to allow white spaces
            isModified: true,
          };
        } else return fld;
      });
      resolve(store.dispatch(setMainContentFieldList(fieldList)));
    }
  });
};

export const updateNavList = (
  caption: string,
  screen?: string,
  idx?: number
) => {
  return new Promise((resolve, reject) => {
    /* get state */
    const state = store.getState();

    /* Duplicate the navigation list */
    var navList = state.mainContent.navList.slice(0);
    var newNavData = {} as INavigation;

    if (screen === "LOGOFF") {
      navList.splice(1, navList.length - 1);
      newNavData = {
        id: caption,
        screen: screen,
      };
      navList.push(newNavData);
    } else if (caption !== "") {
      newNavData = {
        id: caption,
        screen: screen,
      };

      if (
        navList.length === 0 ||
        navList.find(
          (nav) => nav.id === newNavData.id && nav.screen === newNavData.screen
        ) === undefined
      ) {
        navList.push(newNavData);
      } else if (
        navList.findIndex(
          (nav) => nav.id === newNavData.id && nav.screen === newNavData.screen
        ) >= 0
      ) {
        navList.splice(
          navList.findIndex(
            (nav) =>
              nav.id === newNavData.id && nav.screen === newNavData.screen
          ) + 1
        );
      }
    } else if (idx) {
      navList = navList.slice(0, idx + 1);
    } else {
      navList.splice(-1, 1);
    }

    resolve(store.dispatch(setMainContentNavList(navList)));
  });
};
